<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("lineformation.title_edit") }}</h1>
    <form>
      <b-card :title="this.$i18n.t('lineformation.label_edit')" class="w-50">
            <b-form-group
              id="machineList"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('lineformation.label_machine')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="machineList" disabled=true :options="machineOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="lineList"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('lineformation.label_line')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="lineList" :options="lineOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="processList"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('lineformation.label_process')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="processList" :options="processOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("lineformation.button_update") }}</b-button>
            </div>
            <div>
              <b-button variant="danger" @click="deleted" class="float-right px-5">{{ $i18n.t("lineformation.button_delete") }}</b-button>
            </div>
      </b-card>
    </form>
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('lineformation.info_update')" :titleMsg="this.$i18n.t('lineformation.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirm-modal modId="md-confirm2" :msg="this.$i18n.t('lineformation.info_delete')" :titleMsg="this.$i18n.t('lineformation.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="deletedConfirm"/>
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      lineList: null,
      processList: null,
      machineList: null,
      currentPage: 1,
      perPage: 5,
      lineOptions: [
      ],
      processOptions: [
      ],
      machineOptions: [
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      errMsg: null,
      errSbj: null
    }
  },
  created () {
    this.searchLine()
    this.searchProcess()
    this.searchMachine()
    this.lineList = this.$store.store.state.editLineId
    this.processList = this.$store.store.state.editProcessId
    this.machineList = this.$store.store.state.editMachineId
  },
  methods: {
    regist: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.line = this.lineList
      body.process = this.processList
      body.machine = this.machineList
      body.efFlg = '1'

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/lineformation/update', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$store.store.state.editLineId = this.lineList
            this.$store.store.state.editProcessId = this.processList
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    registConfirm: function () {
      this.$bvModal.hide('md-confirm')
    },
    deleted: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.line = this.$store.store.state.editLineId
      body.process = this.$store.store.state.editProcessId
      body.machine = this.machineList
      body.efFlg = '0'

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/lineformation/update', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$store.store.state.editLineId = this.lineList
            this.$store.store.state.editProcessId = this.processList
            this.$bvModal.show('md-confirm2')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    deletedConfirm: function () {
      this.$bvModal.hide('md-confirm2')
      this.$router.push({ path: 'lineFormationmente' })
    },
    searchMachine: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.efFlg = '1'

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/machine/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var machineList = res.data.machineInfo
            if (res.data.machineInfo == null || res.data.machineInfo === 0) {
              return
            }
            var options = []

            // 整形
            for (var i = 0; i < machineList.length; i++) {
              var option = {}
              option.value = machineList[i].machine_id
              option.text = machineList[i].machine_name
              options.push(option)
            }
            // 一旦データクリア
            this.machineOptions.splice(1)
            // データセット
            this.machineOptions.splice(1, 0, ...options)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    searchLine: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.efFlg = '1'

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/line/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var lineList = res.data.lineInfo
            if (res.data.lineInfo == null || res.data.lineInfo === 0) {
              return
            }
            var options = []

            // 整形
            for (var i = 0; i < lineList.length; i++) {
              var option = {}
              option.value = lineList[i].line_id
              option.text = lineList[i].line_name
              options.push(option)
            }
            // 一旦データクリア
            this.lineOptions.splice(1)
            // データセット
            this.lineOptions.splice(1, 0, ...options)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    searchProcess: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      body.efFlg = '1'

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/process/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var processList = res.data.processInfo
            if (res.data.processInfo == null || res.data.processInfo === 0) {
              return
            }
            var options = []

            // 整形
            for (var i = 0; i < processList.length; i++) {
              var option = {}
              option.value = processList[i].process_id
              option.text = processList[i].process_name
              options.push(option)
            }
            // 一旦データクリア
            this.processOptions.splice(1)
            // データセット
            this.processOptions.splice(1, 0, ...options)
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/LineformationmenteEdit.vue